/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DownloadAndSignOptionsSection } from './DownloadAndSignOptionsSection';
import {
    DownloadAndSignOptionsSectionFromJSON,
    DownloadAndSignOptionsSectionFromJSONTyped,
    DownloadAndSignOptionsSectionToJSON,
} from './DownloadAndSignOptionsSection';
import type { IAPTHIRDPARTYRELATIONTYPE } from './IAPTHIRDPARTYRELATIONTYPE';
import {
    IAPTHIRDPARTYRELATIONTYPEFromJSON,
    IAPTHIRDPARTYRELATIONTYPEFromJSONTyped,
    IAPTHIRDPARTYRELATIONTYPEToJSON,
} from './IAPTHIRDPARTYRELATIONTYPE';

/**
 * 
 * @export
 * @interface DownloadAndSignOptionsViewModel
 */
export interface DownloadAndSignOptionsViewModel {
    /**
     * 
     * @type {boolean}
     * @memberof DownloadAndSignOptionsViewModel
     */
    isCustomSelection: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DownloadAndSignOptionsViewModel
     */
    includeThirdParties: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DownloadAndSignOptionsViewModel
     */
    includeFicaAddendumForm: boolean;
    /**
     * 
     * @type {Array<IAPTHIRDPARTYRELATIONTYPE>}
     * @memberof DownloadAndSignOptionsViewModel
     */
    allowedThirdPartyRelationshipTypes: Array<IAPTHIRDPARTYRELATIONTYPE>;
    /**
     * 
     * @type {DownloadAndSignOptionsSection}
     * @memberof DownloadAndSignOptionsViewModel
     */
    beneficiarySection: DownloadAndSignOptionsSection;
    /**
     * 
     * @type {DownloadAndSignOptionsSection}
     * @memberof DownloadAndSignOptionsViewModel
     */
    alternativeBeneficiarySection: DownloadAndSignOptionsSection;
    /**
     * 
     * @type {DownloadAndSignOptionsSection}
     * @memberof DownloadAndSignOptionsViewModel
     */
    lifeInsuredSection: DownloadAndSignOptionsSection;
    /**
     * 
     * @type {DownloadAndSignOptionsSection}
     * @memberof DownloadAndSignOptionsViewModel
     */
    nomineeForOwnershipSection: DownloadAndSignOptionsSection;
    /**
     * 
     * @type {DownloadAndSignOptionsSection}
     * @memberof DownloadAndSignOptionsViewModel
     */
    nomineeSection: DownloadAndSignOptionsSection;
    /**
     * 
     * @type {DownloadAndSignOptionsSection}
     * @memberof DownloadAndSignOptionsViewModel
     */
    financialContributorSection: DownloadAndSignOptionsSection;
    /**
     * 
     * @type {DownloadAndSignOptionsSection}
     * @memberof DownloadAndSignOptionsViewModel
     */
    actingOnBehalfOfSection: DownloadAndSignOptionsSection;
    /**
     * 
     * @type {DownloadAndSignOptionsSection}
     * @memberof DownloadAndSignOptionsViewModel
     */
    relatedPartiesSection: DownloadAndSignOptionsSection;
    /**
     * 
     * @type {DownloadAndSignOptionsSection}
     * @memberof DownloadAndSignOptionsViewModel
     */
    indemnityFormSection: DownloadAndSignOptionsSection;
}

/**
 * Check if a given object implements the DownloadAndSignOptionsViewModel interface.
 */
export function instanceOfDownloadAndSignOptionsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isCustomSelection" in value;
    isInstance = isInstance && "includeThirdParties" in value;
    isInstance = isInstance && "includeFicaAddendumForm" in value;
    isInstance = isInstance && "allowedThirdPartyRelationshipTypes" in value;
    isInstance = isInstance && "beneficiarySection" in value;
    isInstance = isInstance && "alternativeBeneficiarySection" in value;
    isInstance = isInstance && "lifeInsuredSection" in value;
    isInstance = isInstance && "nomineeForOwnershipSection" in value;
    isInstance = isInstance && "nomineeSection" in value;
    isInstance = isInstance && "financialContributorSection" in value;
    isInstance = isInstance && "actingOnBehalfOfSection" in value;
    isInstance = isInstance && "relatedPartiesSection" in value;
    isInstance = isInstance && "indemnityFormSection" in value;

    return isInstance;
}

export function DownloadAndSignOptionsViewModelFromJSON(json: any): DownloadAndSignOptionsViewModel {
    return DownloadAndSignOptionsViewModelFromJSONTyped(json, false);
}

export function DownloadAndSignOptionsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DownloadAndSignOptionsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isCustomSelection': json['IsCustomSelection'],
        'includeThirdParties': json['IncludeThirdParties'],
        'includeFicaAddendumForm': json['IncludeFicaAddendumForm'],
        'allowedThirdPartyRelationshipTypes': ((json['AllowedThirdPartyRelationshipTypes'] as Array<any>).map(IAPTHIRDPARTYRELATIONTYPEFromJSON)),
        'beneficiarySection': DownloadAndSignOptionsSectionFromJSON(json['BeneficiarySection']),
        'alternativeBeneficiarySection': DownloadAndSignOptionsSectionFromJSON(json['AlternativeBeneficiarySection']),
        'lifeInsuredSection': DownloadAndSignOptionsSectionFromJSON(json['LifeInsuredSection']),
        'nomineeForOwnershipSection': DownloadAndSignOptionsSectionFromJSON(json['NomineeForOwnershipSection']),
        'nomineeSection': DownloadAndSignOptionsSectionFromJSON(json['NomineeSection']),
        'financialContributorSection': DownloadAndSignOptionsSectionFromJSON(json['FinancialContributorSection']),
        'actingOnBehalfOfSection': DownloadAndSignOptionsSectionFromJSON(json['ActingOnBehalfOfSection']),
        'relatedPartiesSection': DownloadAndSignOptionsSectionFromJSON(json['RelatedPartiesSection']),
        'indemnityFormSection': DownloadAndSignOptionsSectionFromJSON(json['IndemnityFormSection']),
    };
}

export function DownloadAndSignOptionsViewModelToJSON(value?: DownloadAndSignOptionsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IsCustomSelection': value.isCustomSelection,
        'IncludeThirdParties': value.includeThirdParties,
        'IncludeFicaAddendumForm': value.includeFicaAddendumForm,
        'AllowedThirdPartyRelationshipTypes': ((value.allowedThirdPartyRelationshipTypes as Array<any>).map(IAPTHIRDPARTYRELATIONTYPEToJSON)),
        'BeneficiarySection': DownloadAndSignOptionsSectionToJSON(value.beneficiarySection),
        'AlternativeBeneficiarySection': DownloadAndSignOptionsSectionToJSON(value.alternativeBeneficiarySection),
        'LifeInsuredSection': DownloadAndSignOptionsSectionToJSON(value.lifeInsuredSection),
        'NomineeForOwnershipSection': DownloadAndSignOptionsSectionToJSON(value.nomineeForOwnershipSection),
        'NomineeSection': DownloadAndSignOptionsSectionToJSON(value.nomineeSection),
        'FinancialContributorSection': DownloadAndSignOptionsSectionToJSON(value.financialContributorSection),
        'ActingOnBehalfOfSection': DownloadAndSignOptionsSectionToJSON(value.actingOnBehalfOfSection),
        'RelatedPartiesSection': DownloadAndSignOptionsSectionToJSON(value.relatedPartiesSection),
        'IndemnityFormSection': DownloadAndSignOptionsSectionToJSON(value.indemnityFormSection),
    };
}

